import { useParams } from "react-router-dom";

import MapChart from "./MapChart";
import DistrictSummary from "./DistrictSummary";
import BreadcrumbSearch from "../../common/BreadcrumbSearch";
import Tab from "../../common/Tab";
import NotFound from "../../common/ErrorPage/NotFound";

const Province = (props) => {
  let pidParam = props.searchParam.province;

  const { pid } = useParams();

  if (!pidParam) {
    pidParam = pid;
  }

  const { tab, fetched, provinces, data, parties } = props;

  const province = provinces.find((p) => p.id === parseInt(pidParam));

  if (!province) {
    return <NotFound />;
  }

  const provinceData = (data.provinces && data.provinces.find((pData) => pData.id === province.id)) || { districts: [] };

  return (
    <>
      {/* <Tab tab={tab} handleTabChange={props.handleTabChange} /> */}
      <BreadcrumbSearch tab={tab} showSearch={true} searchParam={props.searchParam} provinces={provinces} handleSearch={props.handleSearch} />
      <MapChart tab={tab} fetched={fetched} province={province} data={provinceData} parties={parties} />
      <DistrictSummary tab={tab} fetched={fetched} province={province} data={provinceData.districts} parties={parties} />
    </>
  );
};

export default Province;
